import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('Token_Kinto_Btck');

    return token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;